<template>
  <button class="action-menu-button" :class="{ loading }" :disabled="loading" v-on="$listeners">
    <slot />
  </button>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class ActionMenuButton extends Vue {
  @Prop({ type: Boolean, default: false })
  loading!: boolean;
}
</script>

<style lang="scss" scoped>
.action-menu-button {
  display: block;
  width: 100%;
  text-align: left;
  padding: 8px 12px;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 0.9rem;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background: rgba($color-theme-red, 0.2);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &.loading {
    cursor: wait;
  }
}
</style>
